import React from 'react';
import { Redirect } from 'react-router-dom';

import accounting from './routesConfig/accounting';
import analyticsAdmin from './routesConfig/analyticsAdmin';
import audioRecordings from './routesConfig/audioRecordings';
import ausFindings from './routesConfig/ausFindings';
import brokersConfig from './routesConfig/brokers';
import capitalMarkets from './routesConfig/capitalMarkets';
import chatEscalation from './routesConfig/chatEscalation';
import closingPortal from './routesConfig/closingPortal';
import companiesConfig from './routesConfig/companies';
import company from './routesConfig/company';
import companyCenter from './routesConfig/companyCenter';
import companyManager from './routesConfig/companyManager';
import crm from './routesConfig/crm';
import dashboardsConfig from './routesConfig/dashboards';
import devToolsConfig from './routesConfig/devTools';
import documentDataConfig from './routesConfig/documentData';
import documentsConfig from './routesConfig/documents';
import error404PageConfig from './routesConfig/error404Page';
import fileRequest from './routesConfig/fileRequest';
import formsConfig from './routesConfig/forms';
import homeConfig from './routesConfig/homePage';
import loanProgressMilestones from './routesConfig/loanProgressMilestones';
import loans from './routesConfig/loans';
import loansIframe from './routesConfig/loansIframe';
import LoginConfig from './routesConfig/login';
import marginCenter from './routesConfig/marginCenter';
import messagesConfig from './routesConfig/messages';
import operations from './routesConfig/operations';
import phone from './routesConfig/phone';
import pipelines from './routesConfig/pipelines';
import profilePageConfig from './routesConfig/profilePage';
import programsConfig from './routesConfig/programs';
import realtorsConfig from './routesConfig/realtors';
import reportsConfig from './routesConfig/reports';
import secondary from './routesConfig/secondary';
import subCompanies from './routesConfig/subCompanies';
import systemConfig from './routesConfig/system';
import tpoCertification from './routesConfig/tpoCertification';
import tpoPortal from './routesConfig/tpoPortal';
import underwriting from './routesConfig/underwriting';
import usersConfig from './routesConfig/users';
import welcomeConfig from './routesConfig/welcomePage';
import workScheduler from './routesConfig/workScheduler';

const routeConfigs = [
  company,
  companyCenter,
  companyManager,
  companiesConfig,
  brokersConfig,
  realtorsConfig,
  systemConfig,
  usersConfig,
  profilePageConfig,
  error404PageConfig,
  LoginConfig,
  dashboardsConfig,
  documentDataConfig,
  formsConfig,
  programsConfig,
  accounting,
  homeConfig,
  audioRecordings,
  workScheduler,
  loanProgressMilestones,
  chatEscalation,
  loans,
  loansIframe,
  marginCenter,
  reportsConfig,
  underwriting,
  secondary,
  documentsConfig,
  operations,
  phone,
  pipelines,
  ausFindings,
  fileRequest,
  welcomeConfig,
  subCompanies,
  tpoCertification,
  tpoPortal,
  closingPortal,
  analyticsAdmin,
  capitalMarkets,
  crm,
  devToolsConfig,
  messagesConfig,
];

const flattenedRoutes = routeConfigs.reduce((acc, config) => {
  const { routes, settings } = config;

  const routesToPush = settings
    ? routes.map(route => ({
        ...route,
        settings: { ...settings, ...route.settings },
      }))
    : routes;

  acc.push(...routesToPush);

  return acc;
}, []);

const routes = [
  ...flattenedRoutes,
  {
    component: () => <Redirect to="/pages/errors/error-404" />,
  },
];

export default routes;
